export default __webpack_public_path__ + "static/media/Gcash_Original.4af3922e.png";